import React, { Component } from 'react';
import styled from 'styled-components';

/*
NOTE!

lazyload init is required before using this component. Can be initialized in index.js with:

import lazySizes from 'lazysizes';
document.addEventListener('lazybeforeunveil', function(e){
    const bg = e.target.getAttribute('data-bgd');
    if(bg) e.target.style.backgroundImage = 'url(' + bg + ')';
});

*/

class Image extends Component {

    render() {
        let { image, ratio, background, minHeight, className, onClick, hoverZoom, style } = this.props;

        ratio = ratio ? ratio.split(':') : [16, 9];
        const perc = (100/Number(ratio[0]))*Number(ratio[1]);

        if(!image || !image.url) return null;
        
        let src = image.url;
        if (image.sizes) {
            if(window.matchMedia("(min-width: 1251px)").matches) {
                src = !isObject(image.sizes.extra_large) ? image.sizes.extra_large : image.sizes.extra_large.url;
            } else if(window.matchMedia("(min-width: 769px) and (max-width: 1250px)").matches) {
                src = !isObject(image.sizes.large) ? image.sizes.large : image.sizes.large.url;
            } else if(window.matchMedia("(max-width: 768px)").matches) {
                src = !isObject(image.sizes.medium) ? image.sizes.medium : image.sizes.medium.url;
            }
        }
        

        //fallback for non existing size
        if(!src) src = !isObject(image.sizes.large) ? image.sizes.large : image.sizes.large.url;
        if(!src) src = !isObject(image.sizes.medium) ? image.sizes.medium : image.sizes.medium.url;
        if(!src) src = !isObject(image.sizes.full) ? image.sizes.full : image.sizes.full.url;

        const placeholder = image.sizes ? (!isObject(image.sizes.min) ? image.sizes.min : image.sizes.min.url) : '';
        
        if(!background) {
            return (
                <img data-src={src} className="lazyload" alt={image.alt} title={image.title} />
            )
        }

        return (
            <ImageWrapper style={style} hoverZoom={hoverZoom} className={className} onClick={onClick} padding={perc.toFixed(2).toString()} minHeight={minHeight}>
                <div className="placeholder" style={{ backgroundImage: `url(${placeholder})` }} />
                <div className="lazyload lazy-image-bgd" data-bg={src} />
            </ImageWrapper>
        )
    }
}

export default Image;

const isObject = v => v && v.constructor !== Array && v === Object(v) && typeof v !== 'function' && v instanceof Promise === false && v instanceof Date === false;

const ImageWrapper = styled.div`
    position:relative;
    padding-top: ${props => props.padding}%;
    overflow:hidden;
    background:#F8F8F8;
    width:100%;

    min-height: ${props => props.minHeight || 'auto' };
    > div {
        position:absolute;
        top:0;
        left:0;
        bottom:0;
        right:0;
        background-size: cover;
        background-repeat:no-repeat;
        background-position:center center;
        background-color: transparent!important;
        &.placeholder {
            transition: none;
            filter: blur(5px);
            top:-5px;
            left:-5px;
            bottom:-5px;
            right:-5px;
            &:hover {
                transform: none;
            }
        }
        &.lazy-image-bgd {
            ${props => props.hoverZoom ? `
                transition: transform .7s ease-out, opacity .3s ease-in-out;
                &:hover {
                    transform: scale(1.05);
                }
            ` : `
                transition: opacity .3s ease-in-out;
            `}
            opacity:0;
        }
        &.lazyloaded {
            opacity: 1;
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/Image.js